export default __webpack_public_path__ + "static/investment-image-8-8b89cf3244f4fbc5c840da1e617d65b9.jpg";